//船舶定义

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 认证状态
 */
class State extends UltMeta {
    UNAUTHENTICATED = new Meta(0, "未认证");
    AUTHENTICATED = new Meta(1, "已认证");
    AUTHENTICATING = new Meta(2, "认证中");
}

export const STATE = new State();

/**
 * 状态
 */
class Status extends UltMeta {
    UNDER_WAY_USING_ENGINE = new Meta(0, "发动机使用中");
    NOT_UNDER_COMMAND = new Meta(2, "未操作");
    RESTRICTED_MANEUVERABILITY = new Meta(3, "操纵能力受限");
    UNDER_WAY_SAILING = new Meta(8, "航行中");
    ENGAGED_IN_FISHING = new Meta(7, "从事捕捞");
    MOTOR_PUSH_OPERATION = new Meta(11, "机动船尾推作业");
    POWER_BOAT_PUSH_OR_SIDE_PUSH_OPERATION = new Meta(12, "机动船顶推或侧推作业");
    AT_ANCHOR = new Meta(1, "锚泊");
    MOORED = new Meta(5, "系泊");
    CONSTRAINED_BY_HER_DRAUGHT = new Meta(4, "吃水受限");
    AGROUND = new Meta(6, "搁浅");
    SAVE_FOR_FUTURE_CORRECTION_NAVIGATION_STATUS = new Meta(9, "留作将来修正导航状态");
    RESERVED_FOR_HSC = new Meta(10, "高速船留用");
    RESERVED_FOR_WIG = new Meta(13, "飞翼船留用");
    CURRENT = new Meta(14, "现行的");
    NOT_DEFINED = new Meta(15, "未定义");
}

export const STATUS = new Status();

/**
 * 展示状态
 */
class ShowStatus extends Status {
    UNDER_WAY_SAILING = new Meta(8, "在航");
}

export const SHOW_STATUS = new ShowStatus();

/**
 * 类型
 */
class Type extends UltMeta {
    WIG = new Meta(1, "飞翼船");
    FISHING_VESSEL = new Meta(2, "捕捞船");
    TUG = new Meta(3, "拖带船");
    SAILBOATS = new Meta(4, "帆船");
    YACHT = new Meta(5, "游艇");
    HSC = new Meta(6, "高速船");
    NAVIGATION_SHIP = new Meta(7, "领航船");
    SEARCH_AND_RESCUE_SHIP = new Meta(8, "搜救船");
    TUGBOAT = new Meta(9, "拖轮");
    PORT_SUPPLY = new Meta(10, "港口供应");
    ANTI_POLLUTION_VESSEL = new Meta(11, "防污船舶");
    LAW_ENFORCEMENT_VESSEL = new Meta(12, "执法船");
    MEDICAL_TRANSPORT = new Meta(13, "医疗运输");
    SPECIAL_SHIPS = new Meta(14, "特殊船");
    PASSENGER_SHIPS = new Meta(15, "客轮");
    CARGO_SHIPS = new Meta(16, "货船");
    TANKER = new Meta(17, "油轮");
    CONTAINER_SHIP = new Meta(18, "集装箱船");
    OTHER = new Meta(19, "其他");
    UNKNOWN = new Meta(20, "未知");
}

export const TYPE = new Type();

/**
 * 操作类型
 */
class OperationType extends UltMeta {
    ENABLE = new Meta(1, "启用");
    DISABLED = new Meta(2, "禁用");
    CLOSE = new Meta(3, "关闭");
}
export const OPERATION_TYPE = new OperationType();

class MonitoringChannels extends UltMeta {
    BACKGROUND = new Meta(1, "管理端");
    MINI_PROGRAM = new Meta(2, "小程序");
}

export const MONITORING_CHANNELS = new MonitoringChannels();

/**
 * 关联设备
 */
class RelatedDevice extends UltMeta {
    ALL = new Meta(1, "全部");
    YES = new Meta(2, "是");
    NO = new Meta(3, "否");
}

export const RELATED_DEVICE = new RelatedDevice();

/**
 * 散货船细分，只有船舶类型为货船（16）
 */
class BulkCargoShipType extends UltMeta {
    CHUANJIANG_SHIP = new Meta(1, "川江船");
    SAND_FLUSHING_SHIP = new Meta(2, "冲砂船");
    FLATBED_SHIP = new Meta(3, "平板舶");
    JIANGHAI_TONG = new Meta(4, "江海通");
}

export const BULK_CARGO_SHIP_TYPE = new BulkCargoShipType();

/**
 * 找船船型
 */
class FindShipType extends UltMeta {
    BULK_CARGO_SHIP = new Meta(1, "散货船");
    SLUGGING_VESSEL = new Meta(2, "直冲船");
    CHUAN_JIANG_SHIP = new Meta(3, "川江船");
    SELF_UNLOADING_BARGE = new Meta(4, "自卸驳");
    SEAGOING_VESSEL = new Meta(5, "海轮");
    FLAT_PLATE_BARGE = new Meta(6, "平板驳船");
}
export const FIND_SHIP_TYPE = new FindShipType();
